export default {
    currentPhotoIndex: null,
    currentSceneId: null,
    recentTargetId: null,
    photosCount: 0
}